<div style="margin: 30px;" *ngIf="!getSessionExpired">
    <h1 style="text-align: center;">
        Задайте вашите финансови въпроси към нашият AI помощник
    </h1>
    <p style="text-align: center;">Нашият изкуствен интелект ще работи лично за вас. Той е предназначен да
        отговори на всички ваши въпроси. Бъдете търпеливи и проявете разбиране към него!</p>
    <div class="card mt-5">
        <div class="card-header">
            <div class="input-group mb-3">
                <input type="text" [(ngModel)]="textResponse.text" class="form-control"
                    placeholder="Напишете вашия въпрос" (keyup.enter)="generateText()" />
                <div class="input-group-append">
                    <button type="button" (click)="generateText()" class="btn btn-primary">Попитай</button>
                </div>
            </div>
        </div>
        <div class="card-body" *ngIf="!loading; else loadingState">
            <p class="card-text">{{textResponse.response}}</p>
            <p *ngIf="!textResponse.response" class="temp-text">Въведете въпрос и натиснете "Попитай", за да получите
                отговор.</p>
        </div>
        <ng-template #loadingState>
            <div class="card-body">
                <div class="loader-overlay">
                    <div class="loader"></div>
                </div>
                <p class="card-text">&nbsp;</p>
            </div>
        </ng-template>
    </div>
</div>

<app-calculator></app-calculator>

<footer>
    <div class="container">
        <div class="row">
            <div class="col-md-6">
                <h3>За нас</h3>
                <p>Ние от MYLEV сме екип от професионалисти в областта на финансите, които вярват, че всеки заслужава да
                    има
                    контрол върху своите финанси. С нашата приложна програма може да проследите разходите си, да
                    получите подробна
                    информация за финансовото си състояние и да управлявате сметките си докато сте в движение.</p>
            </div>
            <div class="col-md-3">
                <h3>За връзка</h3>
                <ul>
                    <li>Димитър Найденов 100</li>
                    <li>Велико Търново, България</li>
                    <li>Email: info@mylev.com</li>
                </ul>
            </div>
            <div class="col-md-3">
                <h3>Последвайте ни в</h3>
                <ul>
                    <li><a href="#">Facebook</a></li>
                    <li><a href="#">Twitter</a></li>
                    <li><a href="#">Instagram</a></li>
                    <li><a href="#">LinkedIn</a></li>
                </ul>
            </div>
        </div>
        <hr>
        <p>Изработено от <a href="http://temelkov.tk" target="_blank">Станислав Tемелков</a> &copy; MYLEV 2023</p>
    </div>
</footer>